/**
 * PROSHOP — Switch d'affichage des prix TTC / HTVA (toggle glissant).
 * Bascule la classe `html.pdw-mode-*` (les 2 prix sont rendus côté serveur, CSS montre
 * le bon) → changement INSTANTANÉ, sans rechargement ni flash. Pose aussi le cookie
 * `pdw_price_mode` (lu côté PHP : tax_display du panier + état initial pré-paint).
 */
(function () {
    'use strict';

    function currentMode() {
        return document.documentElement.classList.contains('pdw-mode-htva') ? 'htva' : 'ttc';
    }

    function setMode(mode) {
        if (mode !== 'ttc' && mode !== 'htva') {
            return;
        }
        if (mode === currentMode()) {
            return;
        }

        // cookie (persistance + cohérence serveur : panier, prochaine navigation)
        document.cookie = 'pdw_price_mode=' + mode + ';path=/;max-age=31536000;samesite=lax';

        // bascule d'affichage immédiate (CSS)
        const root = document.documentElement;
        root.classList.toggle('pdw-mode-htva', mode === 'htva');
        root.classList.toggle('pdw-mode-ttc', mode === 'ttc');

        // synchronise tous les toggles présents (catalogue + fiche)
        document.querySelectorAll('.pdw-price-switch-track').forEach((track) => {
            track.classList.toggle('is-htva', mode === 'htva');
            track.setAttribute('aria-checked', mode === 'htva' ? 'true' : 'false');
        });

        // met à jour le mini-panier (rendu via tax_display, basé sur le cookie)
        if (window.jQuery && jQuery.fn) {
            jQuery(document.body).trigger('wc_fragment_refresh');
        }
    }

    document.addEventListener('click', (e) => {
        const track = e.target.closest('.pdw-price-switch-track');
        if (!track) {
            return;
        }
        e.preventDefault();
        // clic sur une option précise → ce mode ; sinon → bascule l'autre (comportement switch)
        const opt = e.target.closest('.pdw-price-switch-opt');
        const target = opt ? opt.dataset.mode : (currentMode() === 'ttc' ? 'htva' : 'ttc');
        setMode(target);
    });

    // clavier : Espace / Entrée sur le toggle = bascule
    document.addEventListener('keydown', (e) => {
        if (e.key !== ' ' && e.key !== 'Enter') {
            return;
        }
        const track = e.target.closest && e.target.closest('.pdw-price-switch-track');
        if (!track) {
            return;
        }
        e.preventDefault();
        setMode(currentMode() === 'ttc' ? 'htva' : 'ttc');
    });
})();
